import React from 'react'
import { yandexDeliveryApi } from 'api/yandexDelivery'
import { IYandexDropoffStation } from 'models/yandexDelivery'

// У продавца хранится только id пункта сдачи, адрес берём у Яндекса
export const useYandexStation = (stationId?: string | null) => {
  const [station, setStation] = React.useState<IYandexDropoffStation | null>(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  React.useEffect(() => {
    setStation(null)
    setIsError(false)
    if (!stationId) return

    let isCancelled = false
    const loadStation = async () => {
      setIsLoading(true)
      try {
        const response = await yandexDeliveryApi.getDropoffStations({
          pickup_point_ids: [stationId]
        })
        if (isCancelled) return
        setStation(
          response.data.find(
            (item) => item.code === stationId || item.uuid === stationId
          ) ?? null
        )
      } catch {
        if (!isCancelled) setIsError(true)
      } finally {
        if (!isCancelled) setIsLoading(false)
      }
    }

    loadStation()
    return () => {
      isCancelled = true
    }
  }, [stationId])

  return { station, isLoading, isError }
}
